import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { INLINE_ICONS } from '../shared/utils/inline-icons.const';

@Injectable({
  providedIn: 'root',
})
export class IconPreloaderService {
  private iconsLoaded = false;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {}

  preloadIcons(): Promise<void> {
    if (this.iconsLoaded) {
      return Promise.resolve();
    }

    try {
      Object.entries(INLINE_ICONS).forEach(([iconName, svgContent]) => {
        this.matIconRegistry.addSvgIconLiteral(iconName, this.domSanitizer.bypassSecurityTrustHtml(svgContent));
      });

      this.iconsLoaded = true;
      console.log(`Preloaded ${Object.keys(INLINE_ICONS).length} icons`);
      return Promise.resolve();
    } catch (error) {
      console.error('Error preloading inline icons:', error);
      return Promise.reject(error);
    }
  }

  addIcon(iconName: string, svgContent: string): void {
    this.matIconRegistry.addSvgIconLiteral(iconName, this.domSanitizer.bypassSecurityTrustHtml(svgContent));
  }

  areIconsLoaded(): boolean {
    return this.iconsLoaded;
  }
}
